import { RechargeService } from './../../services/recharge.service';
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AuthService } from '../../providers/auth.service'

/*
  充值
*/
@Component({
  selector: 'page-recharge',
  templateUrl: 'rechargemain.html',
  providers: [RechargeService]
})
export class RechargeMain {

  constructor(
    private navPar: NavParams,
    private viewCtrl: ViewController,
    private auth: AuthService,
    private iab: InAppBrowser,
    private rechargeService: RechargeService
  ) { }

  info = this.navPar.data;
  redirectUrl = '';
  ngOnInit() {
    let par = {
      recordId: this.info.RecodeID,
      bankco: null,
      Authorization: this.auth.getToken()
    };
    this.rechargeService.rechargePost(par).then(s => {
      if (s.Result) {
        this.redirectUrl = s.Error;
      }
    });
  }

  //进入第三方支付
  //TQQ 2017-01-04
  payClick() {
    this.iab.create(this.redirectUrl, '_system');
  }

  //页面返回
  //chen 2017-01-19
  close() {
    this.viewCtrl.dismiss();
  }

  openNewSpecifiedWindow(windowName) {
    window.open('about:blank', windowName, 'width=700,height=400,menubar=no,scrollbars=no');
  }

}



// WEBPACK FOOTER //
// ./src/pages/recharge/rechargemain.ts